import { render, staticRenderFns } from "./delete-feedback.vue?vue&type=template&id=63897adf&"
import script from "./delete-feedback.vue?vue&type=script&lang=js&"
export * from "./delete-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports